module.exports = __webpack_public_path__ + "img/j_sample.b354b25e.gif";